import { type SgWorkspace, WorkspaceBoundary, getHomePaths, getTenantAssessmentPaths } from "@sg-protect/shell";
import { type PropsWithChildren, useCallback } from "react";
import { client } from "../../api/client.ts";

export function ModuleWorkspaceBoundary({ children }: PropsWithChildren) {
    const resolveDestination = useCallback((workspace: SgWorkspace) => {
        if (workspace.isPartner) {
            return getHomePaths(workspace.id).root;
        }

        return getTenantAssessmentPaths(workspace.id).home;
    }, []);

    return (
        <WorkspaceBoundary resolveDestination={resolveDestination} client={client}>
            {children}
        </WorkspaceBoundary>
    );
}
